import { ErrorMessage } from "@hookform/error-message";
import ArrowDownDisabledIcon from "Assets/Icons/ArrowDownDisabledicon";
import ArrowDownIcon from "Assets/Icons/ArrowDownIcon";
import { ColourOption } from "Components/CommonComponents/customselectdata";
import Typography from "Components/CommonComponents/Typography";
import { FormErrorMessage } from "Components/InputComponents/formErrorMessage";
import { Controller } from "react-hook-form";
import { default as ReactSelect } from "react-select";
import { components, SingleValueProps, ControlProps } from "react-select";
import "./customSelect.css";

const SingleValue = ({
  children,
  ...props
}: SingleValueProps<ColourOption>) => (
  <components.SingleValue {...props}>{children}</components.SingleValue>
);
// const IndicatorsContainer = (
//   props: IndicatorsContainerProps<ColourOption, true>
// ) => {
//   return (
//     <div
//       style={{
//         background: "transparent",
//         top: props?.selectProps?.name == "customname" ? "0px" : "-1px",
//         position: "relative",
//       }}
//     >
//       <components.IndicatorsContainer {...props} />
//     </div>
//   );
// };
const ControlComponent = (props: ControlProps<ColourOption, false>) => {
  return (
    <div className="d-flex flex-column controlSelectContainer">
      <components.Control {...props} />
    </div>
  );
};
export const MenuList = (props: any) => {
  return (
    <components.MenuList {...props}>
      <div className="menuHeaderStyleMultiSelect">
        <div className="w-100 d-flex flex-column justify-content-start align-items-center">
          <div className="d-flex w-100 flex-row justify-content-end mr-2 mb-1">
            <div
              onClick={() => props.selectProps.addDocumentTypeHandler()}
              className="cursorHoverCSS"
            >
              <Typography variant="body3" color="primary">
                Add Document Type
              </Typography>
            </div>
          </div>
        </div>
      </div>
      {props.children}
    </components.MenuList>
  );
};
const SingleSelectHookForm = (props: any) => {
  const {
    error,
    withSearch,
    name,
    options,
    menuPlacement,
    rules,
    controlName,
    defaultValue,
    isBorder,
  } = props;
  const customStyles = {
    control: (base: any) => ({
      ...base,
      height: "30px",
      minHeigth: "40px !important",
      zIndex: 10,
      border: isBorder === false ? "" : "",
      width: props.width ? props.width : "auto",
      borderColor: props.disabled
        ? "transparent"
        : props.isRequired
        ? "#f5365c"
        : error && error[name]
        ? "#f5365c"
        : props.isSelected
        ? "#00B0F5"
        : "#CCCCCC",
      backgroundColor: props.isSelected
        ? "#E5F6FF"
        : props.disabled
        ? "rgb(242, 242, 242)"
        : "transparent",
    }),
    container: (base: any) => ({
      ...base,
      backgroundColor: "transparent",
      minWidth: props.width ? props.width : "auto",
      zIndex: props.isInPerformance ? 8 : 10,
    }),
    singleValue: (base: any) => ({
      ...base,
      background: "transparent",
      color: "#0f0f0f",
      display: "flex",
      fontSize: "0.875rem",
      fontWeight: "400",
    }),
    option: (base: any, state: any) => ({
      ...base,
      height: "40px",
      display: "flex",
      alignItems: "center",
      padding: "4px 4px",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden",
      fontSize: "16px",
      fontWeight: "400",
      zIndex: 10,
      color: state.isSelected ? "#00B0F5" : "inherit",
      backgroundColor: state.isSelected ? "transparent" : "inherit",
    }),
    menu: (base: any) => ({
      ...base,
      borderRadius: 8,
      marginTop: 4,
      padding: "16px 0px 16px 16px",
      background: "#FFFFFF",
      overflow: "hidden",
      border: isBorder === false ? "0px !important" : "",
    }),
    valueContainer: (base: any) => ({
      ...base,
      width: props.width ? props.width : "auto",
      textOverflow: "ellipsis",
      whiteSpace: "normal",
      overflow: "hidden",
      top: props.top ? props.top : "0px",
      fontSize: "14px",
      fontWeight: "400",
      color: "red",
      padding: "0px 8px 0px 12px",
      justifyContent: "flex-start",
    }),
    placeholder: (base: any) => ({
      ...base,
      fontSize: "16px",
      color: "#cccccc",
    }),
  };

  if (withSearch) {
    return (
      <div>
        <Controller
          control={controlName}
          name={name}
          rules={{ ...rules }}
          defaultValue={defaultValue ? defaultValue : null}
          render={({ field: { onChange } }) => (
            <ReactSelect
              styles={customStyles}
              components={{
                SingleValue,
                MenuList,
                DropdownIndicator,
                IndicatorSeparator: null,
              }}
              theme={(theme) => ({
                ...theme,
                borderRadius: 8,
                colors: {
                  ...theme.colors,
                },
              })}
              options={
                options && Array.isArray(options)
                  ? [...options]
                  : [{ label: "Select", value: null }]
              }
              isDisabled={props.disabled ? true : false}
              onChange={(selected: any) => {
                props.onChange(selected);
                onChange(selected);
              }}
            />
          )}
        />
        {error && error[props.name] != undefined ? (
          <ErrorMessage
            errors={error}
            name={props.name}
            render={({ message }: any) => (
              <FormErrorMessage className="mt-1 input-form-error-message">
                {message}
              </FormErrorMessage>
            )}
          />
        ) : null}
      </div>
    );
  }
  return (
    <Controller
      control={controlName}
      name={name}
      rules={{ ...rules }}
      defaultValue={defaultValue ? defaultValue : null}
      render={({ field: { onChange } }) => (
        <>
          <ReactSelect
            {...props}
            styles={customStyles}
            menuPlacement={menuPlacement ? menuPlacement : "bottom"}
            theme={(theme) => ({
              ...theme,
              borderRadius: 8,
              colors: {
                ...theme.colors,
                primary: "#E1E2E9",
              },
            })}
            components={{
              Control: ControlComponent,
              DropdownIndicator,
              IndicatorSeparator: null,
            }}
            options={
              props.options && Array.isArray(props.options)
                ? [...props.options]
                : [{ label: "Select", value: null }]
            }
            isDisabled={props.disabled ? true : false}
            onChange={(selected: any) => {
              props.onChange(selected);
              onChange(selected);
            }}
          />
          {error && error[props.name] != undefined ? (
            <ErrorMessage
              errors={error}
              name={props.name}
              render={({ message }: any) => (
                <FormErrorMessage className="mt-1 input-form-error-message">
                  {message}
                </FormErrorMessage>
              )}
            />
          ) : null}
        </>
      )}
    />
  );
};
export const DropdownIndicator = (props: any) => {
  if (props.disabled) {
    return <ArrowDownDisabledIcon className="mr-1" />;
  } else {
    return <ArrowDownIcon className="mr-1" />;
  }
};

SingleSelectHookForm.defaultProps = {
  allOption: {
    label: "Select all",
    value: "*",
  },
};

export default SingleSelectHookForm;
